import { Typography } from '@mui/material';

export default function MessageText({ children, sx }) {
  return <Typography sx={{ whiteSpace: 'break-spaces', wordWrap: 'break-word', ...sx }}>{children}</Typography>;
}
